module.exports = require("regenerator-runtime");



// WEBPACK FOOTER //
// ./node_modules/_babel-runtime@6.23.0@babel-runtime/regenerator/index.js